import { Grid } from "@mui/material";
import BrandCard from "./brandCard";

const Brands = ({ brands, show = 9999 }) => {
    const list = brands.filter(brand => brand.product_count > 0).slice(0, show)
    return (
        <Grid container my="-2%" ml="-2%" width="104%" columns={{ xs: 3, sm: 4, lg: 6 }}>
            {
                list.map(brand =>
                    <Grid key={brand.uid} item xs={1} sx={{ p: "2%" }}>
                        <BrandCard img={brand.image} link={"/" + brand.canonical_url} label={brand.name} />
                    </Grid>
                )
            }
        </Grid>
    );
}

export default Brands;